










import Vue, { CreateElement, RenderContext } from 'vue';
import { defineComponent, computed } from '@vue/composition-api';
import { WokDataGridConfiguration, isNumericDataType, formatCellValue, WokDataGridColumn, getCellValue } from './helpers';

export default defineComponent({
    name: 'WokDataGridColumnsTotals',

    props: {
        cfg: {
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        position: {
            type: String,
            required: true
        }
    },

    setup(props, context) {

        const hasTotalForColumn = computed(() => {
            let cfg = <WokDataGridConfiguration>props.cfg;
            if (cfg == null) {
                return [];
            }
            return cfg.columns.map(x => isNumericDataType(x.dataType));
        })

        const totalForColumn = computed(() => {
            let cfg = <WokDataGridConfiguration>props.cfg;
            if (cfg == null) {
                return [];
            }
            return cfg.columns.map((x: WokDataGridColumn, i: number) => {
                if (hasTotalForColumn.value[i]) {
                    let v = 0;
                    if (x.dataAggregate != null) {
                        v = (<any>x.dataAggregate)(props.items, x);
                    }
                    if (x.dataName != null) {
                        v = props.items.reduce((a: number, n: any) => {
                            let cellValue = getCellValue(n.item, 0, x.dataName, x.dataIndex);
                            return (cellValue || 0) + a;
                        }, 0) as number;
                    }
                    return formatCellValue(null, v, i, x.dataType, x.dataPrecision, cfg.locale)

                }
                return 0;
            })
        })

        return {
            hasTotalForColumn,
            totalForColumn
        }
    }
})
